export default __webpack_public_path__ + "static/media/header.86282363.png";